import { render, staticRenderFns } from "./footer-icon.vue?vue&type=template&id=ef30b6d4&functional=true&"
import script from "./footer-icon.vue?vue&type=script&lang=js&"
export * from "./footer-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports